"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faPlus_1 = require("@fortawesome/pro-solid-svg-icons/faPlus");
var embed_react_1 = require("@typeform/embed-react");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var Autocomplete_1 = __importDefault(require("atomicComponents/organisms/Autocomplete"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var hooks_1 = require("containers/MyStack/hooks");
var SimplifyFormInput_1 = __importDefault(require("shared/components/Form/HoC/SimplifyFormInput"));
var single_1 = require("utils/selectors/single");
var SimplifiedAutocomplete = (0, SimplifyFormInput_1.default)(Autocomplete_1.default);
var ServiceNameSelect = function (_a) {
    var _b;
    var isLoading = _a.isLoading, handleAddService = _a.handleAddService;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var allServices = (0, hooks_1.useGetAllServicesNames)();
    var services = (_b = allServices === null || allServices === void 0 ? void 0 : allServices.map(function (service) { return (service === null || service === void 0 ? void 0 : service.trim()); }).filter(Boolean)) !== null && _b !== void 0 ? _b : [];
    var uniqueServices = Array.from(new Set(services));
    uniqueServices.sort();
    var makeServiceOption = function (stat) { return ({ value: stat, label: stat }); };
    var _c = __read(react_1.default.useState(null), 2), serviceName = _c[0], setServiceName = _c[1];
    var popupRef = react_1.default.useRef(); // TODO: change any to a prop that supports openPopup
    var openPopup = function () { var _a; return (_a = popupRef.current) === null || _a === void 0 ? void 0 : _a.open(); };
    var handleChange = function (newValue) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!((newValue === null || newValue === void 0 ? void 0 : newValue.value) && handleAddService)) return [3 /*break*/, 2];
                    setServiceName(newValue);
                    return [4 /*yield*/, handleAddService(newValue)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    setServiceName(null);
                    return [2 /*return*/];
            }
        });
    }); };
    if (!allServices) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(SimplifiedAutocomplete, { options: uniqueServices === null || uniqueServices === void 0 ? void 0 : uniqueServices.map(makeServiceOption), btnProps: { icon: faPlus_1.faPlus, size: 'small', outlined: false }, label: "Add a tool", placeholder: "Select a tool", onChange: handleChange, noOptionsText: "Tool not found", value: serviceName, isDisabled: isLoading, onCreate: openPopup }), (0, jsx_runtime_1.jsx)(embed_react_1.PopupButton, __assign({ id: "OAOmUOAo", as: "span", ref: popupRef, hidden: {
                    userid: profile.id,
                    email: profile === null || profile === void 0 ? void 0 : profile.email,
                    companyid: (profile === null || profile === void 0 ? void 0 : profile.companyId) || '',
                }, style: { display: 'none', width: 0, height: 0 } }, { children: (0, jsx_runtime_1.jsx)("span", {}) }))] }));
};
exports.default = ServiceNameSelect;
